import * as React from 'react'

import { Box, useToggle } from '@factorialco/deprecated-design-system'
import { SettingPageCustomTimeRangeFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import DeleteTimeBlockModal from 'modules/attendance/components/CustomTimeRanges/Content/Table/Modals/DeleteTimeBlockModal'
import SpecialHourWizard from 'modules/attendance/components/CustomTimeRanges/Content/Table/Modals/SpecialHourWizard'
import { useAttendanceSettingWorkCategories } from 'modules/attendance/lib/attendanceSettingWorkCategoriesContext'
import CustomTimeRangeUtils from 'modules/attendance/lib/utils/CustomTimeRangeUtils'

import TagsContent from './TagsContent'

interface Props {
  range: SettingPageCustomTimeRangeFragment
  base: boolean
}

const BlockContent = ({ range, base }: Props) => {
  const { attendanceSetting, companyId } = useAttendanceSettingWorkCategories()
  const [open, toggle] = useToggle(false)
  const [openEditModal, setOpenEditModal] = React.useState(false)
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false)
  const [hover, setHover] = React.useState<boolean>(false)
  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)

  const isDateRange = CustomTimeRangeUtils.withDate(range)
  const customBackround = hover ? 'grey200' : 'grey000White'
  const background = isDateRange ? customBackround : base ? 'grey200' : customBackround

  const onClickEdit = () => {
    track(trackingEvents.timeTracking.specialHoursTableEditPressed)

    setOpenEditModal(true)
  }

  const onClickDelete = () => {
    track(trackingEvents.timeTracking.specialHoursTableRemovePressed)

    setOpenDeleteModal(true)
  }

  return (
    <>
      <PopoverMenu type="list" onClick={toggle(!open)} open={open}>
        <PopoverMenu.Trigger>
          <Box
            onClick={toggle(true)}
            gap="s8"
            alignItems="flexStart"
            justifyContent="spaceBetween"
            background={background}
            border={{
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
            borderRadius={{
              all: 'abs008',
            }}
            padding="s12"
            cursor="pointer"
            maxWidth="full"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            textAlign="left"
          >
            <TagsContent range={range} />
          </Box>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption title={i18n.t('common.edit')} onClick={onClickEdit} />
          <PopoverMenu.TouchableOption
            title={i18n.t('common.delete')}
            onClick={onClickDelete}
            danger
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      {openEditModal && <SpecialHourWizard range={range} onClose={() => setOpenEditModal(false)} />}
      {openDeleteModal && (
        <DeleteTimeBlockModal
          attendanceSetting={attendanceSetting}
          companyId={companyId}
          range={range}
          onClose={() => setOpenDeleteModal(false)}
        />
      )}
    </>
  )
}

export default BlockContent
